import { useState } from "react";
import ExcelJS from "exceljs";
import { readRulesAndExecuteOnFile } from "../functions/runRules";
import {
  prepareWorkSheetFromCSVFilePapaParser,
  extractExcelRows,
  readFileAsText,
  applyOutputFileSettings,
} from "../utils";

const useHandleFileUpload = () => {
  const [parsedCSV, setParsedCSV] = useState([]);
  let finalSummary = null;

  const handleFileUpload = async (file, ruleData) => {
    if (!file) return;
    const fileName = ruleData.mappingName;
    const isCSV = file.type === "text/csv" || file.name.endsWith(".csv");
    const isExcel =
      file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
      file.name.endsWith(".xlsx");

    if (!isCSV && !isExcel) {
      console.error(
        "Unsupported file type. Please upload a CSV or Excel file.",
      );
      return;
    }

    try {
      // Create workbook and worksheets
      const wb = new ExcelJS.Workbook();
      let worksheet, outputSheet;

      if (isCSV) {
        // Handle CSV file
        const csvData = await readFileAsText(file);
        worksheet = wb.addWorksheet("inputsheet");
        worksheet = prepareWorkSheetFromCSVFilePapaParser(
          csvData,
          worksheet,
          setParsedCSV,
        );
      } else {
        // Handle Excel file
        await wb.xlsx.load(await file.arrayBuffer());
        worksheet = wb.getWorksheet(1);

        // Extract and process Excel data
        const extractedRows = extractExcelRows(worksheet);
        setParsedCSV(extractedRows);
      }

      // Common processing for both file types
      outputSheet = wb.addWorksheet("OutputSheet");
      let { outputSheet: generatedSheet, summary } = readRulesAndExecuteOnFile(
        worksheet,
        outputSheet,
        ruleData.mappingData,
        ruleData.inputColumns,
        ruleData.outputColumns,
        ruleData.fileSettings,
        ruleData.outputFileSettings,
        fileName,
      );
      finalSummary = summary;
      // Update outputSheet reference
      // applyOutputFileSettings
      applyOutputFileSettings(
        generatedSheet,
        ruleData?.outputFileSettings,
        fileName,
      );
    } catch (error) {
      console.error("Error processing file:", error);
    }

    return { finalSummary };
  };

  return { handleFileUpload };
};

export default useHandleFileUpload;
